import * as d3 from 'd3'
import { TFunction } from 'i18next'

interface PartialChart<DATA> {
  destroy?: () => void
  update(props: { data: DATA; lng: string; t: TFunction }): void
}

export default function createBasicChart<DATA>(factory: ($svg: SVGSVGElement) => PartialChart<DATA>) {
  return function basicFactory($container: HTMLElement) {
    const $svg = d3.select($container).append('svg').style('display', 'block')

    const chart = factory($svg.node()!)

    function update(props: { data: DATA; lng: string; t: TFunction }) {
      // SVG
      const svgSize = $container.getBoundingClientRect()
      $svg.attr('width', svgSize.width).attr('height', svgSize.height)

      chart.update(props)
    }

    let latestLocale = 'en'
    let latestTranslateFunction: TFunction = ((a: any) => a) as any
    let latestData: DATA | undefined = undefined

    let req: number | undefined = undefined
    function scheduleUpdate(data?: DATA) {
      latestData = data || latestData
      if (!req) {
        window.requestAnimationFrame(() => {
          if (latestData) {
            update({ data: latestData, lng: latestLocale, t: latestTranslateFunction })
          }
          req = undefined
        })
      }
    }

    const resizeObserver = new ResizeObserver((e) => {
      if (
        String(e[0].contentBoxSize[0].inlineSize) != $svg.attr('width') ||
        String(e[0].contentBoxSize[0].blockSize) != $svg.attr('height')
      ) {
        scheduleUpdate()
      }
    })
    resizeObserver.observe($container)

    const updateData = (data: DATA) => scheduleUpdate(data)

    const setLocale = (lng: string, t: TFunction) => {
      latestLocale = lng
      latestTranslateFunction = t
      scheduleUpdate()
    }

    const destroy = () => {
      $svg.node()?.remove()
      resizeObserver.disconnect()
    }

    return { updateData, setLocale, destroy }
  }
}
